import AnimatedSvg, { anim, DELAY, FILL_BOX, resolveTrigger } from "./AnimatedSvg";

/**
 * Dashboard cihaz durum çubuğu ikonları (#233) — varsayılan tetik "always".
 * Müşteride (UsersIcon), Depoda (PartsBoxIcon), Plasiyerde (PlaymakerTruckIcon)
 * ve Cihaz Konumları (MapPinDropIcon) diğer setlerden paylaşılır; buradakiler
 * yalnız bu çubuğa özgü olanlar.
 *
 * Ortak props: { className, trigger = "always" | "hover" | "off", animated, title }
 */

/** Serviste — İngiliz anahtarı ileri geri çevrilir */
export function ServiceToolIcon({ className, trigger, animated = true, title }) {
  const t = resolveTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={`origin-center ${anim(t, "iconWrench")}`} style={FILL_BOX}>
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9l-3.8 3.8Z" />
      </g>
    </AnimatedSvg>
  );
}

/** Testte — beherde kabarcıklar yükselir */
export function TestBeakerIcon({ className, trigger, animated = true, title }) {
  const t = resolveTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M9 3h6M10 3v6.5L4.8 18.6A1.6 1.6 0 0 0 6.2 21h11.6a1.6 1.6 0 0 0 1.4-2.4L14 9.5V3" />
      <path d="M7 15h10" />
      <circle cx="10.5" cy="18" r="0.9" className={anim(t, "iconRise")} />
      <circle cx="13.5" cy="17.5" r="0.7" className={anim(t, "iconRise", DELAY.d2)} />
    </AnimatedSvg>
  );
}

/** Dashboard başlığı — mikroçip; bacaklarından sinyal akar */
export function ChipIcon({ className, trigger, animated = true, title }) {
  const t = resolveTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <rect x="6.5" y="6.5" width="11" height="11" rx="2" />
      <rect x="9.5" y="9.5" width="5" height="5" rx="1" className={`origin-center ${anim(t, "iconPop")}`} style={FILL_BOX} />
      <path d="M9.5 3v3.5M14.5 3v3.5M9.5 17.5V21M14.5 17.5V21" className={anim(t, "iconBlink")} />
      <path d="M3 9.5h3.5M3 14.5h3.5M17.5 9.5H21M17.5 14.5H21" className={anim(t, "iconBlink", DELAY.d2)} />
    </AnimatedSvg>
  );
}
